import { render, staticRenderFns } from "./UIToggle.vue?vue&type=template&id=7c3805a5"
import script from "./UIToggle.vue?vue&type=script&lang=js"
export * from "./UIToggle.vue?vue&type=script&lang=js"
import style0 from "./UIToggle.vue?vue&type=style&index=0&id=7c3805a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports